import { employmentDocumentMessages, romeTimeMessages } from '@fide/shared';
// Source locale. en.ts and es.ts must provide every key (checked by TypeScript).
export const it = {
  ...romeTimeMessages('it'),
  ...employmentDocumentMessages('it'),
  "org.title": "Organizzazione",
  "org.explanation": "Le unità descrivono l’organigramma e non concedono accessi. Il responsabile diretto gestisce le richieste del team. L’ambito esteso deve essere assegnato esplicitamente: include i team subordinati attraverso responsabili attivi, senza accesso HR a documenti o contratti.",
  "org.units": "Reparti e unità",
  "org.newUnit": "Nuova unità",
  "org.archived": "Archiviata",
  "org.noUnits": "Nessuna unità configurata.",
  "org.people": "Persone e responsabilità",
  "org.search": "Cerca nome o matricola",
  "org.count": "Persone trovate: {n}",
  "org.manager": "Responsabile diretto",
  "org.subtree": "Gestisce anche i team subordinati",
  "org.direct": "Solo riporti diretti",
  "org.unassigned": "Non assegnato",
  "org.unitEditor": "Unità organizzativa",
  "org.name": "Nome unità",
  "org.parent": "Unità superiore",
  "org.root": "Radice aziendale",
  "org.archive": "Archivia unità",
  "org.archiveHint": "Si archivia solo un’unità senza persone o sotto-unità. Nessuna cancellazione dei dati.",
  "org.clearManager": "Rimuovi responsabile",
  "org.findManager": "Cerca un responsabile attivo",
  "org.accessWarning": "La catena modifica chi può vedere presenze, saldi e richieste e approvarle. Ogni livello esteso richiede un responsabile attivo con ruolo abilitato. Nessuna autoapprovazione. Le e-mail restano indirizzate al responsabile diretto e a HR.",
  "org.confirm": "Confermo la struttura e l’ambito di accesso mostrati.",
  "org.invalid": "Configurazione non valida: controlla ruolo, stato e unità.",
  "org.cycle": "La struttura creerebbe un ciclo tra unità o responsabili.",
  "org.stale": "La struttura è cambiata. Chiudi la modifica, ricarica e riprova.",
  "org.busy": "Un’altra modifica è in corso. Riprova.",
  "org.inUse": "L’unità contiene persone o sotto-unità. Riassegnale prima di archiviarla.",
  "org.limit": "Limite di 500 unità raggiunto.",
  "wizard.identity": "Persona e destinatario",
  "wizard.employment": "Rapporto di lavoro",
  "wizard.documents": "Documenti e accordi",
  "wizard.documentsHint": "Definisci ciò che HR dovrà verificare dopo la creazione. Il destinatario resta l'indirizzo e-mail controllato nel primo passaggio.",
  "wizard.employmentContractRequired": "Il contratto di lavoro sarà aggiunto alla checklist e potrà essere collegato alla versione del rapporto dalla scheda del dipendente.",
  "wizard.individualAgreement": "È previsto un accordo individuale separato",
  "wizard.noSignatureClaim": "La checklist registra solo la verifica amministrativa: non prova firma, consegna, accettazione o validità legale.",
  "wizard.required": "Richiesto",
  "wizard.notRequired": "Non previsto",
  "wizard.review": "Riepilogo e invito",
  "wizard.steps": "Passaggi di inserimento",
  "wizard.next": "Continua",
  "wizard.previous": "Indietro",
  "wizard.create": "Crea dipendente e invia invito",
  "wizard.confirm": "Ho verificato dati, azienda e destinatario. Confermo la creazione della scheda e l’invio dell’invito.",
  "wizard.delivery": "L’invito di accesso sarà inviato a {email}.",
  "wizard.scope": "La creazione della scheda non firma un contratto e non certifica un’assunzione o l’applicabilità del CCNL.",
  "wizard.unknown": "Non registrato",
  "wizard.fixRequired": "Completa o correggi i dati e riprova la lettura dei riferimenti prima di confermare.",
  'employment.datesInvalid':'Verifica le date: inizio richiesto prima di indicare fine contratto/prova; inizio non oltre la decorrenza, contratto non scaduto alla decorrenza e prova entro il periodo del rapporto.',
  "employment.employment_start": "Inizio del rapporto",
  "employment.contract_end": "Fine contratto comunicata",
  "employment.probation_end": "Fine prova comunicata",
  "employment.datesHint": "Date confermate da HR: vuoto significa dato non registrato. Non calcolano la prova, non rinnovano il contratto e non causano cessazioni automatiche.",
  'draft.title':'Assunzioni da completare',
  'draft.hint':'Bozze riservate a HR e titolare, eliminate dopo 30 giorni senza salvataggi. Salvare non crea dipendenti né invia e-mail.',
  'draft.empty':'Nessuna bozza salvata.',
  'draft.unnamed':'Bozza senza nome',
  'draft.completed':'Dipendente creato: verifica l’invito nella sua scheda.',
  'draft.delivery':'Consegna invito',
  'draft.resume':'Riprendi',
  'draft.discard':'Rimuovi bozza',
  'draft.discardConfirm':'Rimuovere la bozza o il promemoria? Il dipendente già creato non viene eliminato.',
  'draft.closeConfirm':'Chiudere senza salvare? Usa “Salva bozza e chiudi” per riprendere in seguito.',
  'draft.save':'Salva bozza e chiudi',
  'draft.invalid':'Bozza non valida. Verifica i campi; non inserire allegati o dati medici.',
  'draft.conflict':'Bozza modificata o alta già completata. Chiudi e riprendi dalla lista aggiornata. Verifica il dipendente prima di reinviare l’invito.',
  'draft.unavailable':'Bozza scaduta o non disponibile. Ricarica la lista.',
  'draft.limit':'Limite di 100 bozze raggiunto. Rimuovi quelle non necessarie.',
  "calendarConfig.invalid": "Data o tipo non validi. Verifica i dati.",
  "calendarConfig.stale": "Questa eccezione è stata modificata. Ricarica prima di salvare.",

  "workCalendar.company": "Eccezione aziendale",
  "workCalendar.site": "Eccezione della sede",
  "workCalendar.personal": "Eccezione personale",

  "calendarConfig.title": "Festività ed eccezioni",
  "calendarConfig.hint": "Valgono per il giorno di inizio del turno. Una giornata lavorativa usa gli intervalli salvati, non inventa ore. Nessun campo per dati medici.",
  "calendarConfig.empty": "Nessuna eccezione configurata",
  "calendarConfig.scope": "Azienda o sede",
  "calendarConfig.kind": "Tipo",
  "calendarConfig.company": "Tutta l’azienda",
  "calendarConfig.personal": "Eccezione personale",
  "calendarConfig.patron": "Patrono: giorno non lavorativo",
  "calendarConfig.closure": "Chiusura: giorno non lavorativo",
  "calendarConfig.workday": "Giornata lavorativa",
  "calendarConfig.confirm": "Confermo data, ambito e tipo",

  "workCalendar.title": "Calendario previsto",
  "workCalendar.hint": "Previsione dagli orari salvati e festivi nazionali. Non certifica presenza né ricalcola richieste o saldi.",
  "workCalendar.unknown": "Orario o riferimento lavorativo incompleto",
  "workCalendar.national": "Festivo nazionale",
  "workCalendar.minutes": "Minuti di orario previsti",
  "workCalendar.previous": "Mese precedente",
  "workCalendar.next": "Mese successivo",

  "schedule.title": "Orario settimanale",
  "schedule.hint": "Ora italiana. Pause come intervalli vuoti; non modifica timbrature, ferie o saldi.",
  "schedule.empty": "Orario non configurato",
  "clockPolicy.title": "Tolleranze orarie",
  "clockPolicy.hint": "Valori dichiarati da HR per questa versione dell’orario e per la sede; non sono dedotti dal CCNL.",
  "clockPolicy.notConfigured": "Nessuna tolleranza configurata per questo orario.",
  "clockPolicy.effectiveFrom": "In vigore dal",
  "clockPolicy.lateStart": "Tolleranza dopo l’inizio previsto",
  "clockPolicy.earlyEnd": "Tolleranza prima della fine prevista",
  "clockPolicy.minutes": "minuti",
  "clockPolicy.scheduleVersion": "Versione dell’orario",
  "clockPolicy.source.label": "Fonte dichiarata",
  "clockPolicy.source.company_policy": "Politica aziendale",
  "clockPolicy.source.employment_agreement": "Accordo di lavoro",
  "clockPolicy.source.consultant_review": "Verifica del consulente del lavoro",
  "clockPolicy.noEffect": "Il valore viene solo registrato e mostrato. Non modifica timbrature, ore, paghe o report; HR deve verificare la regola prima di usarla.",
  "clockPolicy.confirm": "Confermo i valori dichiarati e la loro data di decorrenza.",
  "clockPolicy.addVersion": "Registra una versione delle tolleranze",
  "clockPolicy.stale": "La politica è cambiata in un’altra sessione. Ricaricala.",
  "clockPolicy.scheduleMismatch": "La versione dell’orario scelta non è in vigore in questa data.",
  "schedule.days": "Lunedì|Martedì|Mercoledì|Giovedì|Venerdì|Sabato|Domenica",
  "schedule.next": "Giorno successivo",
  "schedule.incompatible": "Dati lavorativi cambiati: orario da riconfermare.",
  "schedule.minutes": "Minuti settimanali",
  "schedule.day": "Giorno",
  "schedule.start": "Inizio",
  "schedule.end": "Fine",
  "schedule.add": "Aggiungi intervallo",
  "schedule.remove": "Rimuovi intervallo",
  "schedule.confirm": "Confermo intervalli e decorrenza",
  "schedule.invalid": "Intervalli o totale settimanale non validi.",

  "companyCcnl.title": "CCNL aziendali con decorrenza",
  "companyCcnl.hint": "Salvare il primo riferimento attiva il controllo sulle nuove assegnazioni individuali: codice e data devono rientrare in questa lista. I dati storici non cambiano. Le date sono organizzative, non certificano applicabilità legale.",
  "companyCcnl.active": "Controllo attivo: le nuove assegnazioni devono corrispondere a un periodo aziendale disponibile.",
  "companyCcnl.closeEnd": "Data finale di assegnazione",
  "companyCcnl.initial": "Riferimento CCNL iniziale",
  "audit.table.company_ccnls": "Riferimenti CCNL aziendali",
  "audit.field.company_ccnl_id": "Riferimento CCNL assegnato",
  "audit.field.ccnl_policy_enabled": "Controllo dei riferimenti CCNL aziendali",
  "audit.field.effective_from": "Decorrenza",
  "audit.field.effective_to": "Data finale",
  "audit.field.closed_at": "Data di chiusura",
  "audit.field.voided_at": "Data di ritiro",
  "audit.field.code": "Codice",
  "companyCcnl.empty": "Lista non configurata: le nuove schede usano ancora riferimenti liberi.",
  "companyCcnl.open": "Senza data finale",
  "companyCcnl.end": "Data finale di assegnazione (facoltativa)",
  "companyCcnl.close": "Chiudi periodo",
  "companyCcnl.closeHint": "La chiusura è definitiva e non può precedere oggi né assegnazioni future. I rapporti esistenti restano conservati.",
  "companyCcnl.voidHint": "Ritira solo un riferimento non utilizzato. Il controllo resta attivo anche con lista vuota.",
  "companyCcnl.invalid": "Seleziona un CCNL aziendale disponibile alla data di decorrenza.",
  "companyCcnl.overlap": "Periodi sovrapposti per lo stesso codice.",
  "companyCcnl.inUse": "Riferimento già ritirato o utilizzato: non può essere ritirato.",
  "companyCcnl.closeInvalid": "Data finale non valida o incompatibile con assegnazioni future.",
  "employment.companyCcnlPeriod": "Periodo del riferimento CCNL aziendale: {from} – {to}",

  'worklists.updated': 'I dati sono cambiati. Elenco aggiornato dalla prima pagina.',
  "company.identityHint": "La partita IVA identifica questa azienda e non è modificabile dalla scheda. I campi opzionali non sono requisiti di attivazione; il CCNL qui è un riferimento, non una regola automatica di maturazione.",
  "company.edit": "Modifica dati aziendali",
  "company.setup": "Configurazione iniziale",
  "company.setupHint": "Questi controlli descrivono i dati configurati, non certificano la disponibilità del servizio. Verifica anche chiosco, inviti, permessi e apertura del cedolino sul dispositivo.",
  "company.registered": "Azienda registrata",
  "company.sites": "Sedi registrate: {count}. Apri per configurare chioschi e metodi di timbratura.",
  "company.recipients": "Dipendenti con account e chiave attivi: {ready} / {total}. Sono esclusi titolari, HR e responsabili. Verifica inviti e dispositivi nelle schede.",
  "company.invalid": "Controlla il formato o la lunghezza di questo campo.",
  "company.conflict": "Dati cambiati o accesso non più disponibile. Annulla, aggiorna la pagina e verifica prima di riprovare.",
  "company.savedRefreshFailed": "Le modifiche sono state salvate, ma l'aggiornamento dei dati della sessione non è riuscito. Riprova la lettura; non salvare di nuovo.",
  "register.created": "Azienda registrata",
  "register.createdReady": "Caricamento dell'accesso aziendale in corso.",
  "register.createdRefreshFailed": "L'azienda è stata registrata, ma il caricamento dell'accesso non è riuscito. Riprova la lettura senza registrarla di nuovo.",

  "invitations.title": "Invitazioni",
  "invitations.historyHint": "Stato del link, non prova di consegna dell’e-mail. Il token non viene conservato in chiaro: per condividere di nuovo occorre creare un nuovo link, invalidando quello precedente.",
  "invitations.status.pending": "Valida",
  "invitations.status.expired": "Scaduta",
  "invitations.status.redeemed": "Accettata",
  "invitations.status.revoked": "Revocata",
  "invitations.created": "Creata",
  "invitations.expires": "Scade",
  "invitations.redeemed": "Accettata il",
  "invitations.revoke": "Revoca link",
  "invitations.confirmRevoke": "Revocare questo link? Non potrà più essere usato per attivare l’account.",
  "invitations.empty": "Nessuna invitazione registrata.",
  'directory.filters': 'Filtri dei dipendenti',
  'directory.search': 'Nome, matricola, e-mail o codice fiscale',
  'directory.unassigned': 'Senza sede assegnata',
  'directory.sort': 'Ordina per',
  'directory.sort.name-asc': 'Nome · A–Z',
  'directory.sort.name-desc': 'Nome · Z–A',
  'directory.sort.number-asc': 'Matricola · crescente',
  'directory.sort.number-desc': 'Matricola · decrescente',
  'directory.results': 'Dipendenti filtrati: {filtered} / {total}. Sede, ruolo e stato sono quelli attuali.',
  'directory.unavailable': 'Elenco e conteggi non disponibili finché i dati non sono caricati correttamente.',
  'directory.noResults': 'Nessun dipendente corrisponde ai filtri. Azzera i filtri per vedere l’elenco completo.',
  'directory.pagination': 'Pagine dei dipendenti',
  'directory.tableScroll': 'Tabella dipendenti scorrevole orizzontalmente',
  "employees.myProfile": "La mia scheda",
  "member.tab.employment": "Dati lavorativi",
  "employment.reload": "Ricarica",
  "employment.saved": "Versione salvata.",
  "employment.new": "Nuova versione / sostituzione",
  "employment.copy": "Usa come base",
  "employment.withdraw": "Annulla versione futura",
  "employment.confirmWithdraw": "Annullare questa versione futura? Il registro resta consultabile.",
  "employment.save": "Salva versione",
  "employment.stale": "I dati sono cambiati. Ricarica prima di salvare.",
  "employment.dateInvalid": "La data non può precedere la versione più recente né modificare il passato.",
  "employment.notFuture": "Si può annullare solo una versione futura ancora valida.",
  "employment.title": "Dati lavorativi",
  "employment.hint": "Riferimenti inseriti da HR: non sono un contratto firmato e non attivano il calcolo dei saldi. La mansione non concede permessi di accesso.",
  "employment.job_title": "Mansione",
  "employment.category": "Categoria",
  "employment.level": "Livello",
  "employment.contract_type": "Tipo di contratto",
  "employment.ccnl_reference": "Riferimento CCNL",
  "employment.weekly_hours": "Ore settimanali",
  "employment.effective_from": "Decorrenza",
  "employment.empty": "Dati lavorativi non ancora inseriti da HR.",
  "ccnl.search": "Cerca per codice, nome o settore",
  "ccnl.snapshot": "Copia locale del catalogo generata il {date}.",
  "ccnl.stale": "La copia del catalogo richiede una verifica di aggiornamento (soglia operativa: 14 giorni). I riferimenti salvati restano conservati; conferma testo e rinnovi con il consulente.",
  "ccnl.effectiveFrom": "Decorrenza riportata da CNEL",
  "ccnl.expiry": "Scadenza contrattuale riportata da CNEL",
  "ccnl.classification": "Stato di classificazione CNEL",
  "ccnl.agreement": "Tipo di accordo",
  "ccnl.received": "Data di ricezione CNEL",
  "ccnl.datesHint": "Questi dati descrivono il record del catalogo. Una scadenza passata o uno stato di classificazione non determinano da soli l’applicabilità del CCNL. Conferma testo e rinnovi con il consulente.",
  "ccnl.missing": "Il riferimento salvato non compare in questa copia del catalogo. È conservato; verifica il codice con il consulente prima di sostituirlo.",
  "ccnl.selected": "Contratto collettivo CNEL",
  "ccnl.none": "Seleziona un riferimento",
  "ccnl.unknown": "Non confermato dal consulente",
  "ccnl.legacy": "Riferimento precedente: {value}",
  "ccnl.unavailable": "Catalogo CNEL non disponibile. Riprova quando la connessione è attiva.",
  "ccnl.hint": "Fonte: Archivio Corrente CNEL. La selezione è un riferimento da confermare con il consulente, non determina l’applicabilità né calcola automaticamente i saldi.",
  "employment.onboardingHint": "Inserisci i dati del rapporto prima di invitare il dipendente. Sono riferimenti operativi, non un contratto firmato e non attivano calcoli automatici di orario o ferie.",
  "employment.current": "In vigore",
  "employment.past": "Storico",
  "employment.future": "Programmato",
  "employment.voided": "Annullato / sostituito",
  'app.tagline': 'Portale aziendale',
  'common.save': 'Salva',
  'common.cancel': 'Annulla',
  'common.close': 'Chiudi',
  'common.company': 'Azienda',
  'common.language': 'Lingua',
  'common.loading': 'Caricamento…',
  'common.edit': 'Modifica',
  'common.add': 'Aggiungi',
  'common.copy': 'Copia',
  'common.copied': 'Copiato',
  'common.retry': 'Riprova',
  'common.logout': 'Esci',
  'common.actions': 'Azioni',
  'common.none': 'Nessuno',
  'common.optional': 'facoltativo',

  'nav.presence': 'Presenze',
  'nav.cartellino': 'Cartellino',
  'nav.employees': 'Dipendenti',
  'nav.sites': 'Sedi e chioschi',
  'nav.payroll': 'Documenti',
  'nav.compensation': 'Retribuzioni',
  'nav.requests': 'Richieste',
  'nav.communications': 'Comunicazioni',
  'communications.eyebrow': 'BACHECA AZIENDALE',
  'communications.title': 'Comunicazioni',
  'communications.hint': 'Avvisi in testo semplice visibili ai lavoratori attivi. Nessun allegato o conferma di lettura.',
  'communications.compose': 'Nuovo avviso',
  'communications.subject': 'Titolo',
  'communications.body': 'Messaggio',
  'communications.expiry': 'Scadenza (facoltativa)',
  'communications.scope': 'Sarà visibile a tutti i lavoratori attivi dell’azienda.',
  'communications.publish': 'Pubblica avviso',
  'communications.published': 'Avviso pubblicato.',
  'communications.error': 'Non è stato possibile completare l’operazione. Riprova.',
  'communications.archiveTitle': 'Avvisi pubblicati',
  'communications.archive': 'Archivia',
  'communications.publishedAt': 'Pubblicato il {date}',
  'communications.expiresAt': 'Scade il {date}',
  'communications.empty': 'Nessun avviso attivo.',
  'communications.results': 'Avvisi {from}–{to} di {total}',
  'communications.pagination': 'Pagine degli avvisi',
  'communications.archiveConfirmTitle': 'Archiviare l’avviso?',
  'communications.archiveConfirmBody': 'L’avviso «{title}» non sarà più visibile ai lavoratori. Confermi?',
  'common.skipToContent': 'Vai al contenuto',
  'nav.audit': 'Registro attività',
  'nav.settings': 'Impostazioni',

  'config.missingTitle': 'Portale non configurato',
  'config.missingBody':
    'Imposta VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY in apps/web-portal/.env (vedi .env.example) e riavvia.',

  'login.title': 'Accedi al portale',
  'login.subtitle': 'Nessuna password: un codice via e-mail oppure la passkey di questo dispositivo.',
  'login.email': 'E-mail di lavoro',
  'login.sendCode': 'Inviami il codice',
  'login.codeSent': 'Ti abbiamo inviato un codice a {email}.',
  'login.linkHint': 'Se nell’e-mail trovi un link invece del codice, aprilo in questo stesso browser.',
  'login.code': 'Codice di 6 cifre',
  'login.verify': 'Accedi',
  'login.passkey': 'Accedi con passkey',
  'login.or': 'oppure',
  'login.changeEmail': 'Usa un altro indirizzo',

  'access.noCompanyTitle': 'Nessuna azienda collegata a questo account',
  'access.noCompanyBody': 'Se sei il titolare o l’HR di un’azienda, registrala. Se sei un dipendente, usa l’invito ricevuto e l’app Fide.',
  'access.registerCompany': 'Registra la tua azienda',
  'access.employeeTitle': 'Questo portale è per HR e titolari',
  'access.employeeBody': 'Per timbrare, vedere i cedolini e chiedere ferie usa l’app Fide sul telefono.',

  'register.title': 'Registra la tua azienda',
  'register.legalName': 'Ragione sociale',
  'register.vat': 'Partita IVA',
  'register.vatInvalid': 'Partita IVA non valida (11 cifre con cifra di controllo).',
  'register.ownerName': 'Il tuo nome e cognome',
  'register.fiscalCode': 'Codice fiscale dell’azienda',
  'register.pec': 'PEC',
  'register.sdi': 'Codice SDI',
  'register.inps': 'Matricola INPS',
  'register.ccnl': 'CCNL applicato',
  'register.address': 'Sede legale',
  'register.submit': 'Registra azienda',
  'register.note': 'Diventerai titolare dell’account aziendale. Potrai aggiungere l’HR e i dipendenti subito dopo.',

  'presence.title': 'Presenze',
  'presence.live': 'In tempo reale',
  'presence.inNow': 'Presenti ora',
  'presence.today': 'Timbrature di oggi',
  'presence.empty': 'Ancora nessuna timbratura oggi.',
  'presence.in': 'Entrata',
  'presence.out': 'Uscita',
  'presence.receipt': 'Ricevuta',
  'presence.employee': 'Dipendente',
  'presence.time': 'Ora',
  'presence.method': 'Metodo',
  'presence.flags': 'Segnalazioni',

  'report.title': 'Report mensile per il consulente del lavoro',
  'report.body': 'Entrate, uscite, ore lavorate, assenze approvate e anomalie per dipendente e giorno, in ora italiana. Serve per elaborare paghe e LUL, non li sostituisce. Il file viene creato in questo browser.',
  'report.scopeNotice': 'BOZZA PER LA VERIFICA DEL CONSULENTE DEL LAVORO. Somma gli intervalli tra timbrature e le assenze approvate; non conosce l’orario contrattuale, le pause, i festivi per sede né le regole CCNL. Non calcola paghe o straordinari e non è un file d’importazione validato. Riconciliare prima dell’uso.',
  'report.month': 'Mese',
  'report.prepare': 'Prepara il report',
  'report.loading': 'Preparazione…',
  'report.empty': 'Nessuna timbratura né assenza in questo mese.',
  'report.ready': '{employees} dipendenti · {lines} giornate',
  'report.anomalies': '{n} anomalie da verificare prima di inviare il file (vedi colonna «Anomalie»).',
  'report.detail': 'Scarica dettaglio giornaliero (CSV)',
  'report.summary': 'Scarica riepilogo per dipendente (CSV)',
  'report.dayUnit': 'g',
  'report.allocationRequired': 'Esportazione bloccata: {employee}, {code}, dal {from} al {to}, quantità approvata {quantity}. Il riparto giornaliero non è determinabile con il calendario attuale (lun–ven, esclusi festivi nazionali). Concordare il riparto con il consulente; non modificare la richiesta storica per farla coincidere con il calendario.',
  'report.col.number': 'Matricola',
  'report.col.cf': 'Codice fiscale',
  'report.col.employee': 'Dipendente',
  'report.col.date': 'Data',
  'report.col.intervals': 'Entrate-Uscite',
  'report.col.hours': 'Ore (hh:mm)',
  'report.col.hundredths': 'Ore (centesimi)',
  'report.col.absences': 'Assenze',
  'report.col.anomalies': 'Anomalie',
  'report.col.days': 'Giorni lavorati',
  'report.col.anomalyCount': 'N. anomalie',
  'report.anomaly.missing_out': 'uscita mancante',
  'report.anomaly.missing_in': 'entrata mancante',
  'report.anomaly.long_shift': 'turno oltre 16 ore',
  'report.anomaly.corrected': 'corretta da HR',
  'report.anomaly.flagged': 'segnalazione sulla timbratura',
  'method.geo': 'Posizione',
  'method.qr': 'QR chiosco',
  'method.manual': 'Correzione',
  'flag.late_sync': 'Sincronizzata in ritardo',
  'flag.clock_skew': 'Orologio del telefono sfasato',
  'flag.sequence': 'Due timbrature uguali di fila',
  'flag.outside_geofence': 'Fuori dalla sede',
  'flag.mock_location': 'Posizione simulata',
  'flag.manual_correction': 'Correzione approvata',
  'flag.hr_entry': 'Registrata da HR',
  'flag.unclosed_break': 'Uscita con pausa ancora aperta',

  'employees.title': 'Dipendenti',
  'employees.add': 'Nuovo dipendente',
  'employees.onboardingInviteSent': 'Dipendente creato e invito accettato dal servizio di invio. Questo non conferma la consegna nella casella del lavoratore.',
  'employees.onboardingInviteFailed': 'Il dipendente è già stato creato, ma non è stato possibile confermare l’invio dell’invito.',
  'employees.onboardingRetryHint': 'Riprovare emetterà un nuovo invito e invaliderà ogni link precedente. Se la prima e-mail è arrivata, quel link smetterà di funzionare.',
  'employees.onboardingRetry': 'Emetti e invia un altro invito',
  'employees.onboardingFinish': 'Termina',
  'employees.onboardingProfile': 'Apri la scheda del dipendente',
  'employees.onboardingNextSteps': 'Dalla scheda puoi controllare i documenti lavorativi e completare la checklist. Puoi salvare una bozza retributiva cifrata solo per HR; pubblicala al dipendente dopo aver verificato il dispositivo registrato.',
  'employees.fullName': 'Nome e cognome',
  'employees.email': 'E-mail',
  'employees.cf': 'Codice fiscale',
  'employees.cfInvalid': 'Codice fiscale non valido.',
  'employees.number': 'Matricola',
  'employees.site': 'Sede',
  'employees.role': 'Ruolo',
  'employees.status': 'Stato',
  'employees.device': 'Dispositivo',
  'employees.deviceRegistered': 'Associato',
  'employees.actions': 'Azioni',
  'employees.noDevice': 'Nessun dispositivo',
  'employees.invite': 'Invita',
  'employees.inviteTitle': 'Invito per {name}',
  'employees.inviteBody':
    'Invieremo il link a {email}. Vale 7 giorni e funziona solo con quell’indirizzo. Puoi anche condividerlo a mano (WhatsApp, SMS, QR stampato).',
  'employees.inviteSend': 'Invia invito per e-mail',
  'employees.inviteLinkOnly': 'Solo link, da condividere a mano',
  'employees.inviteEmail': 'Invia per e-mail',
  'employees.inviteEmailed': 'E-mail inviata a {email}. Il link qui sopra è lo stesso.',
  'employees.inviteEmailFailed': 'L’e-mail non è partita. Condividi il link a mano oppure riprova tra poco.',
  'employees.inviteNewLinkHint': 'Crea un link nuovo: quello precedente smette di funzionare.',
  'employees.inviteNoEmail': 'Questo dipendente non ha un indirizzo e-mail: senza, non può attivare l’account. Aggiungilo nei suoi dati.',
  'employees.empty': 'Nessun dipendente. Aggiungi il primo.',

  'import.button': 'Importa CSV',
  'import.title': 'Importa dipendenti da CSV',
  'import.body': 'Esporta l’anagrafica dal software paghe o da Excel in CSV. Colonne riconosciute: nome e cognome (oppure Nome e Cognome), e-mail, codice fiscale, matricola, sede. Il file viene letto in questo browser e nulla viene salvato finché non confermi.',
  'import.template': 'Scarica il modello',
  'import.file': 'File CSV',
  'import.missingName': 'Il file non ha una colonna con il nome: serve «Nome e cognome» oppure «Nome» e «Cognome».',
  'import.empty': 'Il file non contiene righe da importare.',
  'import.summary': '{ready} da importare · {exists} già presenti · {errors} da correggere',
  'import.line': 'Riga',
  'import.status.ready': 'Da importare',
  'import.status.exists': 'Già presente',
  'import.status.error': 'Da correggere',
  'import.existing': 'già registrato come {name}',
  'import.noEmail': 'senza e-mail: non potrà ricevere l’invito',
  'import.issue.name_missing': 'nome mancante',
  'import.issue.name_too_long': 'nome troppo lungo',
  'import.issue.email_invalid': 'e-mail non valida',
  'import.issue.cf_invalid': 'codice fiscale non valido',
  'import.issue.number_too_long': 'matricola troppo lunga',
  'import.issue.site_unknown': 'sede non trovata',
  'import.issue.duplicate_in_file': 'ripete la riga {line}',
  'import.skipped': 'Le righe da correggere non verranno importate: correggile e importa di nuovo il file.',
  'import.tooMany': 'Al massimo {max} dipendenti per file: dividilo in più file.',
  'import.submit': 'Importa {n} dipendenti',
  'import.done': 'Importati {n} dipendenti. Ora puoi invitarli dalla lista.',
  'import.rowFailed': 'Riga {line}: {reason}. Nessun dipendente è stato importato.',
  'import.reason.email_taken': 'e-mail già usata da un altro dipendente',
  'import.reason.cf_taken': 'codice fiscale già presente in azienda',
  'import.reason.invalid': 'valore non valido',
  'import.reason.site': 'sede non valida',
  'import.reason.other': 'errore imprevisto',
  "roles.guideTitle": "Ruoli e responsabili: chi può fare cosa",
  "roles.guideBody": "In Gestisci → Dati scegli il ruolo di accesso e il responsabile diretto. In Gestisci → Dati lavorativi registri mansione, categoria, livello e CCNL con decorrenza: non concedono permessi. In Organizzazione configuri reparti, sotto-unità, catene di responsabili e deleghe temporanee. Ogni persona ha un solo responsabile diretto. L’ambito esteso abilita i team subordinati, senza accesso HR a documenti o contratti.",
  "roles.scope.employee": "Usa l’app per i propri dati, timbrature, richieste e documenti. Nessun accesso al portale aziendale.",
  "roles.scope.manager": "Accede a presenze, report e richieste della squadra assegnata. Può approvare richieste del team, mai le proprie. Non accede alle pagine HR per dipendenti, cedolini, sedi o richieste GDPR.",
  "roles.scope.hr_admin": "Gestisce dipendenti, presenze, richieste, invii cifrati di documenti, sedi e richieste GDPR dell’azienda. Può nominare responsabili; solo il titolare cambia i ruoli HR e Titolare.",
  "roles.scope.company_owner": "Ha le funzioni HR e può assegnare o revocare i ruoli HR e Titolare. Deve restare almeno un titolare attivo.",
  "roles.confirmTitle": "Cambiare il ruolo di {name}: {from} → {to}?",
  "roles.confirmBody": "Questa modifica cambia i permessi di accesso. È salvata separatamente dagli altri dati del modulo. I permessi richiedono anche un profilo attivo.",
  "roles.releasesTeam": "{n} persone resteranno senza questo responsabile: {names}. Dovrai assegnare un nuovo responsabile; l’HR può continuare a gestire le richieste.",
  "roles.selfChange": "Stai cambiando il tuo ruolo: potresti perdere l’accesso a parti del portale.",
  "roles.confirm": "Conferma cambio di ruolo",
  'role.employee': 'Dipendente',
  'role.manager': 'Responsabile',
  'role.hr_admin': 'HR',
  'role.company_owner': 'Titolare',
  'status.invited': 'Invitato',
  'status.active': 'Attivo',
  'status.suspended': 'Sospeso',
  'status.erased': 'Cancellato',

  'sites.title': 'Sedi e chioschi',
  'sites.add': 'Nuova sede',
  'sites.empty': 'Nessuna sede configurata. Aggiungi una sede per iniziare.',
  'sites.noKiosks': 'Nessun chiosco configurato per questa sede.',
  'sites.retrySites': 'Riprova a caricare le sedi',
  'sites.retryKiosks': 'Riprova a caricare i chioschi',
  'sites.name': 'Nome',
  'sites.address': 'Indirizzo',
  'sites.latitude': 'Latitudine',
  'sites.longitude': 'Longitudine',
  'sites.radius': 'Raggio (m)',
  'sites.geo': 'Timbratura con posizione',
  'sites.geoWarning':
    'Attivala solo dopo l’accordo sindacale o l’autorizzazione dell’Ispettorato (art. 4 L. 300/1970). Fino ad allora si timbra con il QR del chiosco.',
  'sites.qrOnly': 'Solo QR',
  'sites.geoOn': 'Posizione + QR',
  'sites.kiosks': 'Chioschi',
  'sites.addKiosk': 'Nuovo chiosco',
  'sites.kioskName': 'Nome del chiosco (es. Ingresso)',
  'sites.pairingTitle': 'Abbina il tablet',
  'sites.pairingBody': 'Sul tablet all’ingresso apri {url} e inserisci questo codice entro 10 minuti:',
  'sites.revokeKiosk': 'Disattiva',
  'sites.revokeTitle': 'Disattivare il chiosco {name}?',
  'sites.revokeWarning': 'Il chiosco {name} non potrà più registrare timbrature QR. Per riprendere le timbrature da questo tablet sarà necessario abbinare un nuovo chiosco.',
  'sites.pairingMissing': 'Il chiosco è stato creato, ma il codice di abbinamento non è arrivato. Non riprovare: contatta l’assistenza.',
  'kioskStatus.pairing': 'Da abbinare',
  'kioskStatus.active': 'Attivo',
  'kioskStatus.revoked': 'Disattivato',

  'kiosk.pairTitle': 'Abbina questo chiosco',
  'kiosk.pairBody': 'Inserisci il codice mostrato nel portale (Sedi e chioschi → Nuovo chiosco).',
  'kiosk.code': 'Codice di abbinamento',
  'kiosk.pair': 'Abbina',
  'kiosk.scan': 'Inquadra il codice con l’app Fide per timbrare',
  'kiosk.refresh': 'Nuovo codice tra {s} s',
  'kiosk.unpair': 'Scollega chiosco',
  'kiosk.clockWarning': 'L’orologio di questo dispositivo è sfasato di {s} s: correggilo, altrimenti le timbrature verranno rifiutate.',

  'payroll.title': 'Documenti del personale',
  'comp.title': 'Riferimenti retributivi',
  'comp.intro': 'Cifrati nel browser e leggibili su un telefono HR autorizzato e sul telefono del dipendente. Fide non custodisce chiavi di recupero.',
  'comp.employee': 'Dipendente', 'comp.choose': 'Seleziona un dipendente', 'comp.label': 'Descrizione del riferimento',
  'comp.amount': 'Importo', 'comp.currency': 'Valuta', 'comp.frequency': 'Periodicità', 'comp.frequency.hourly': 'Oraria',
  'comp.frequency.monthly': 'Mensile', 'comp.frequency.annual': 'Annuale', 'comp.frequency.one_time': 'Una tantum',
  'comp.effective': 'Valido dal', 'comp.replaces': 'Corregge il riferimento', 'comp.new': 'Nuovo riferimento',
  'comp.save': 'Cifra e salva', 'comp.saving': 'Cifratura e salvataggio…', 'comp.saved': 'Riferimento salvato cifrato.',
  'comp.empty': 'Nessun riferimento registrato.', 'comp.history': 'Storico cifrato', 'comp.privacy': 'Importi e descrizioni in chiaro non vengono inviati al database: vi viene salvato solo il contenuto cifrato. I riferimenti non sono cedolini e non producono calcoli o diritti automatici.',
  'comp.keys': 'Chiavi mobili autorizzate', 'comp.verify': 'Ho confrontato questo codice con il telefono Fide indicato.',
  'comp.keyMismatch': 'Il fingerprint non corrisponde alle chiavi pubbliche. Salvataggio bloccato.',
  'comp.keyChanged': 'La chiave mobile è cambiata: confronta il nuovo codice sul telefono prima di continuare.',
  'comp.noKey': 'Manca una chiave mobile attiva del dipendente o dell’utente HR corrente.', 'comp.error': 'Impossibile completare l’operazione. Verifica chiavi e connessione.',
  'comp.conflict': 'Un’altra sessione ha già corretto questo riferimento. Lo storico è stato aggiornato; seleziona la versione corrente e riprova.',
  'comp.saveDraft': 'Salva bozza cifrata', 'comp.draftSaved': 'Bozza cifrata salvata per i telefoni HR.',
  'comp.draftHint': 'La bozza è cifrata solo per i telefoni HR verificati. Il dipendente non può leggerla finché un telefono HR non la pubblica per la sua chiave attiva.',
  'comp.drafts': 'Bozze cifrate', 'comp.draftsEmpty': 'Nessuna bozza in attesa.',
  'comp.draftExpires': 'Scade il {date}', 'comp.draftsPublish': 'Apri Riferimenti retributivi su un telefono HR autorizzato per controllare e pubblicare una bozza.',
  'comp.discardDraft': 'Elimina bozza', 'comp.discardDraftConfirm': 'Eliminare definitivamente questa bozza cifrata?', 'comp.draftDiscarded': 'Bozza cifrata eliminata.',
  'comp.read': 'Richiedi la lettura sul portale', 'comp.selectRead': 'Seleziona i riferimenti da leggere', 'comp.qrTitle': 'Scansiona con il telefono HR autorizzato',
  'comp.qrHint': 'Apri Riferimenti retributivi nell’app Fide HR e scansiona questo codice. Confronta il codice di sicurezza mostrato anche sul telefono.',
  'comp.fingerprint': 'Codice di verifica: {code}', 'comp.waiting': 'In attesa dell’approvazione dal telefono HR…',
  'comp.cancel': 'Annulla richiesta', 'comp.readDone': 'Riferimenti letti tramite approvazione mobile. Chiudi questa schermata per cancellare la copia temporanea.',
  'comp.expired': 'La richiesta è scaduta. Avviane una nuova.', 'comp.readError': 'Il telefono non può aprire questi riferimenti o la richiesta è scaduta.',
  'comp.close': 'Chiudi e cancella',
  'comp.maxRead': 'Puoi richiedere la lettura di massimo 25 riferimenti per volta.',
  'comp.maxRecipients': 'Sono consentiti fino a 100 telefoni autorizzati per riferimento.',
  'payroll.privacy':
    'Il PDF viene diviso e cifrato in questo browser. Fide riceve solo file cifrati che può aprire esclusivamente il telefono del dipendente.',
  'payroll.kind': 'Tipo',
  'kind.cedolino': 'Cedolino',
  'kind.contract': 'Contratto / lettera di assunzione',
  'kind.contract_change': 'Variazione contrattuale',
  'kind.training_certificate': 'Attestato di formazione',
  'kind.hr_notice': 'Comunicazione HR',
  'kind.tfr': 'TFR / liquidazione',
  'kind.cu': 'Certificazione Unica',
  'kind.other': 'Altro documento',
  'payroll.period': 'Mese di riferimento',
  'payroll.reference.month': 'Mese della busta paga',
  'payroll.reference.taxYear': 'Anno fiscale di riferimento',
  'payroll.reference.date': 'Data di riferimento',
  'payroll.docTitle': 'Titolo',
  'payroll.file': 'PDF cumulativo (Zucchetti, TeamSystem…)',
  'payroll.fileDocument': 'PDF del documento (può contenere pagine di più persone)',
  'payroll.analyze': 'Analizza',
  'payroll.analyzing': 'Lettura del PDF…',
  'payroll.pages': '{n} pagine',
  'payroll.matched': 'Pronti da inviare',
  'payroll.issues': 'Da controllare',
  'payroll.noKey': 'Nessun dispositivo attivo: non può ancora ricevere documenti cifrati.',
  'payroll.issue.unassigned': 'Pagina {page}: nessun dipendente riconosciuto.',
  'payroll.issue.ambiguous': 'Pagina {page}: contiene più dipendenti.',
  'payroll.issue.identity_conflict': 'Pagina {page}: il codice fiscale e il nome indicano dipendenti diversi.',
  'payroll.issue.unknown_employee': 'Pagina {page}: codice fiscale non presente in azienda.',
  'payroll.publish': 'Cifra e pubblica {n} documenti',
  'payroll.encrypting': 'Cifratura {done}/{total}…',
  'payroll.uploading': 'Caricamento {done}/{total}…',
  'payroll.publishing': 'Pubblicazione…',
  'payroll.done': 'Pubblicati {n} documenti: i dipendenti li trovano nell’app Fide, sezione Documenti.',
  'payroll.new': 'Nuovo invio',
  'payroll.recipients': 'Destinatari',
  'payroll.pagesCol': 'Pagine',
  'payroll.continuation': 'pagine senza codice fiscale aggiunte a chi precede: {pages}',
  'payroll.manual': 'assegnate a mano: {pages}',
  'payroll.state.ready': 'Pronto',
  'payroll.state.reissue': 'Riemissione: nuovo telefono',
  'payroll.state.delivered': 'Già consegnato',
  'payroll.state.no_key': 'Nessun dispositivo attivo',
  'payroll.state.key_changed': 'Dispositivo cambiato',
  'payroll.state.key_mismatch': 'Codice di sicurezza incoerente: non inviare',
  'payroll.firstUse': 'prima volta',
  'payroll.firstUseHint': 'Primo documento cifrato per questo telefono da questo browser. Puoi confrontare il codice di sicurezza con l’app del dipendente (I miei dati → Questo telefono).',
  'payroll.sendAgain': 'Invia di nuovo (sostituisce)',
  'payroll.verify': 'Verifica',
  'payroll.assign': 'Assegna a',
  'payroll.dontSend': '— Non inviare —',
  'payroll.skippedPages': '{n} pagine non verranno inviate.',
  'payroll.verifyTitle': 'Verifica il telefono di {name}',
  'payroll.verifyBody': 'Il telefono di questo dipendente è cambiato. Chiedigli di aprire Fide → I miei dati → Questo telefono e di leggerti il codice di sicurezza. Conferma solo se coincide con quello attuale; altrimenti non inviare e contatta il supporto Fide.',
  'payroll.verifyPrevious': 'Codice di sicurezza precedente',
  'payroll.verifyCurrent': 'Codice di sicurezza attuale',
  'payroll.verifyConfirm': 'Il codice coincide',
  'payroll.trustUnavailable': 'Questo browser non può conservare i codici di sicurezza verificati (navigazione privata?): ogni telefono verrà considerato nuovo.',
  'payroll.encryptedPdf': 'Il PDF è protetto da password. Esportalo senza protezione dal software paghe.',
  'payroll.notPdf': 'Il file non è un PDF leggibile.',
  'payroll.cryptoBroken': 'Questo browser non supera la verifica crittografica: aggiorna Chrome, Edge, Firefox o Safari.',
  'payroll.retry': 'Riprova',
  'payroll.reset': 'Nuovo PDF',
  'payroll.nothingToSend': 'Nessun documento da inviare.',
  'payroll.history': 'Storico invii',
  'payroll.historyEmpty': 'Nessun invio finora.',
  'payroll.historyRange': 'Invii {from}–{to} di {total}',
  'payroll.historyPagination': 'Pagine degli invii',
  'payroll.documentsRange': 'Documenti {from}–{to} di {total}',
  'payroll.documentsPagination': 'Pagine dei documenti',
  'payroll.noDocuments': 'Nessun documento in questo invio.',
  'payroll.opened': '{opened}/{total} aperti',
  'payroll.draft': 'Non pubblicato',

  'requests.title': 'Richieste',
  'requests.leave': 'Ferie e permessi',
  'requests.corrections': 'Timbrature dimenticate',
  'requests.overtime': 'Lavoro straordinario e Banca Ore',
  'requests.smartWorking': 'Lavoro agile',
  'requests.compensationType': 'Destinazione',
  'requests.compensation.payout': 'Liquidazione in busta paga',
  'requests.compensation.banca_ore': 'Banca Ore (Riposo compensativo)',
  'requests.empty': 'Nessuna richiesta in attesa.',
  'requests.approve': 'Approva',
  'requests.reject': 'Rifiuta',
  'requests.verifyProtocol': 'Verifica PUC',
  'requests.verifyProtocolTitle': 'Verifica il protocollo di {name}',
  'requests.verifyProtocolHint': 'Controlla questo PUC nel servizio INPS per il datore di lavoro. Fide registra la tua conferma, ma non interroga INPS.',
  'requests.verifyProtocolConfirm': 'Confermo di aver controllato il PUC nel servizio INPS.',
  'requests.sickAwaitingHr': 'In attesa della verifica HR',
  'requests.sickVerified': 'PUC verificato da HR',
  'requests.sickLegacy': 'Nessuna verifica PUC registrata in Fide',
  'requests.amendSick': 'Correggi/proroga',
  'requests.amendSickTitle': 'Correggi la malattia di {name}',
  'requests.sickChangeKind': 'Operazione',
  'requests.sickExtension': 'Proroga',
  'requests.sickCorrection': 'Correzione',
  'requests.periodFrom': 'Dal',
  'requests.periodTo': 'Al',
  'requests.amendReason': 'Motivo della modifica',
  'requests.amendSickHint': 'La richiesta originale resta nello storico. Il nuovo periodo torna in attesa della verifica HR del PUC.',
  'requests.period': 'Periodo',
  'requests.quantity': 'Quantità',
  'requests.reason': 'Motivo',

  'audit.title': 'Registro attività',
  'audit.when': 'Quando',
  'audit.what': 'Cosa',
  'audit.actor': 'Chi',
  'audit.subject': 'Dipendente',
  'audit.actorUnknown': 'Utente non più disponibile',
  'audit.actorSystem': 'Sistema',
  'audit.empty': 'Nessuna attività registrata.',
  'audit.note': 'Registro amministrativo e di sicurezza degli ultimi 90 giorni: chi ha agito e quali campi ha cambiato, senza valori personali. I cambi di lingua non vengono registrati.',
  'audit.pagination': 'Paginazione del registro attività',
  'audit.results': 'Eventi {from}–{to} di {total}',
  'audit.table.companies': 'Dati aziendali',
  'audit.table.sites': 'Sedi',
  'audit.table.members': 'Schede dipendenti e ruoli',
  'audit.table.member_identities': 'Identità dei dipendenti',
  'audit.table.invitations': 'Inviti',
  'audit.table.kiosk_devices': 'Chioschi',
  'audit.table.device_keys': 'Dispositivi dei dipendenti',
  'audit.table.punch_corrections': 'Correzioni delle timbrature',
  'audit.table.payroll_batches': 'Invii di documenti',
  'audit.table.documents': 'Documenti del personale',
  'audit.table.leave_types': 'Tipi di assenza',
  'audit.table.leave_balances': 'Saldi di ferie e permessi',
  'audit.table.leave_requests': 'Richieste di assenza',
  'audit.table.gdpr_requests': 'Richieste privacy',
  'audit.table.company_announcements': 'Avvisi aziendali',
  'audit.table.employment_terms': 'Condizioni contrattuali',
  'audit.table.other': 'Altro record aziendale',
  'audit.field.status': 'stato',
  'audit.field.revoked_at': 'data di revoca',
  'audit.field.preferred_language': 'lingua preferita',
  'audit.field.geo_enabled': 'geolocalizzazione attiva',
  'audit.field.latitude': 'latitudine della sede',
  'audit.field.longitude': 'longitudine della sede',
  'audit.field.manager_member_id': 'responsabile assegnato',
  'audit.field.site_id': 'sede assegnata',
  'audit.field.first_opened_at': 'prima apertura del documento',
  'audit.field.published_at': 'data di pubblicazione',
  'audit.field.decided_at': 'data della decisione',
  'audit.field.decided_by': 'autore della decisione',
  'audit.field.auth_user_id': 'account collegato',
  'audit.field.other': 'altri campi modificati',
  'op.INSERT': 'creato',
  'op.UPDATE': 'modificato',
  'op.DELETE': 'eliminato',

  'settings.title': 'Impostazioni',
  'settings.company': 'Dati aziendali',
  'settings.passkeys': 'Passkey',
  'settings.passkeysBody':
    'Una passkey ti fa entrare con lo sblocco di questo dispositivo (PIN, password o il metodo che usi già), senza codici via e-mail. La verifica la fa il dispositivo: Fide non riceve nulla.',
  'settings.addPasskey': 'Registra una passkey su questo dispositivo',
  'settings.noPasskeys': 'Nessuna passkey registrata.',
  'settings.passkeyAdded': 'Passkey registrata.',
  'settings.saved': 'Salvato.',

  'error.signupNotAllowed': 'Durante il pilota la registrazione è su invito. Scrivici per abilitare la tua azienda.',
  'error.emailNotConfirmed': 'Conferma prima il tuo indirizzo e-mail.',
  'error.forbidden': 'Non hai i permessi per questa operazione.',
  'error.notAuthenticated': 'Sessione scaduta: accedi di nuovo.',
  'error.memberNotInvitable': 'Il dipendente ha già attivato il suo account.',
  'error.memberEmailMissing': 'Aggiungi prima l’e-mail del dipendente.',
  'error.lastOwner': 'L’azienda deve avere almeno un titolare.',
  'error.deviceKeyNotActive': 'Un dipendente ha cambiato telefono nel frattempo: analizza di nuovo il PDF.',
  'error.uploadIncomplete': 'Alcuni file non sono stati caricati: riprova.',
  'error.supersedesInvalid': 'Il documento da sostituire non è più valido: analizza di nuovo il PDF.',
  'error.notDraft': 'Questo invio è già stato pubblicato.',
  'error.pairingCodeInvalid': 'Codice non valido o scaduto.',
  'error.notPending': 'Richiesta già gestita.',
  'error.duplicate': 'Esiste già.',
  'error.invalidValue': 'Uno dei valori non è valido.',
  'error.generic': 'Qualcosa è andato storto. Riprova.',
  'error.idempotencyConflict': 'I dati di questa registrazione sono cambiati durante il nuovo tentativo. Verifica la scheda prima di inviarla di nuovo.',

// Block 1: lifecycle, HR entries, withdrawal, GDPR inbox
  'error.terminationDateRequired': 'Indica l’ultimo giorno di lavoro.',
  'error.terminationDateInvalid': 'La data di cessazione non può essere futura né più vecchia di un anno: registrala dall’ultimo giorno di lavoro.',
  'error.emailLocked': 'L’e-mail è l’accesso del dipendente: si può correggere solo finché non ha attivato l’account.',
  'error.managerInvalid': 'Scegli come responsabile un’altra persona attiva della stessa azienda.',
  'error.memberErased': 'I dati di questa persona sono stati cancellati.',
  'error.selfEntry': 'Non puoi registrare per te stesso: deve farlo un’altra persona di HR o il titolare.',
  'error.memberNotActive': 'Questa persona non è attiva in quella data.',
  'error.reasonRequired': 'Scrivi il motivo (almeno 3 caratteri).',
  'error.tsInFuture': 'Non si può registrare un orario futuro.',
  'error.protocolRequired': 'Per la malattia serve il numero di protocollo del certificato INPS.',
  'error.leaveTypeInactive': 'Questo tipo di assenza non è attivo.',
  'error.alreadyWithdrawn': 'Il documento è già stato ritirato.',
  'error.answerRequired': 'Scrivi la risposta per il dipendente.',
  'error.alreadyResolved': 'Richiesta già chiusa.',
  'error.alreadyExtended': 'La proroga si può usare una sola volta.',
  'error.deadlinePassed': 'Il primo mese è già passato: non si può più prorogare, rispondi subito.',
  'error.memberNotTerminated': 'Questa cancellazione è possibile solo per ex dipendenti.',
  'nav.privacy': 'Privacy (GDPR)',
  'status.terminated': 'Cessato',
  'employees.manage': 'Gestisci',
  'member.tab.data': 'Dati',
  'member.tab.status': 'Stato e telefono',
  'member.tab.entries': 'Registra per conto',
  'member.emailInvitedHint': 'Puoi correggerla finché non attiva l’account: gli inviti già mandati smettono di valere.',
  'member.emailLockedHint': 'È l’indirizzo con cui accede all’app: non si può cambiare da qui.',
  'member.cfChangeHint': 'Il codice fiscale decide quali pagine dei cedolini riceve: controlla bene.',
  'member.manager': 'Responsabile delle richieste',
  'member.language': 'Lingua dell’app',
  'member.saved': 'Dati salvati.',
  'member.statusTitle': 'Stato',
  'member.terminatedInfo': 'Ultimo giorno: {day}. Può vedere i suoi documenti fino al {until}.',
  'member.suspendedSince': 'Sospeso dal {when}.',
  'member.selfNote': 'Non puoi cambiare il tuo stato né registrare per te stesso.',
  'member.invitedNote': 'Non ha ancora attivato l’account: per ora puoi solo invitarlo o correggerne i dati.',
  'member.suspend': 'Sospendi',
  'member.reactivate': 'Riattiva',
  'member.undoTermination': 'Annulla la cessazione',
  'member.terminate': 'Registra la cessazione',
  'member.suspendExplain': 'Blocca subito ogni accesso: non può timbrare, vedere i documenti né fare richieste. Si può annullare in qualsiasi momento. Le timbrature fatte prima, ancora in coda sul telefono, restano valide.',
  'member.terminateExplain': 'Da subito non può più timbrare né fare richieste; le ferie chieste dopo l’ultimo giorno vengono annullate. Per 12 mesi può ancora vedere e scaricare i suoi documenti, e tu puoi inviargli il cedolino finale, il TFR e la CU.',
  'member.reactivateExplain': 'Torna ad avere pieno accesso: timbrature, richieste e documenti.',
  'member.suspendConfirm': 'Sospendi l’accesso',
  'member.terminateConfirm': 'Registra la cessazione',
  'member.reactivateConfirm': 'Riattiva',
  'member.lastDay': 'Ultimo giorno di lavoro',
  'member.lastDayHint': 'Potrà vedere i suoi documenti fino al {until}.',
  'member.statusDone': 'Stato aggiornato: {status}.',
  'member.cancelledRequests': 'Annullate {n} richieste di assenza successive all’ultimo giorno.',
  'member.reportsWarning': '{n} persone hanno ancora questa persona come responsabile: assegna loro un nuovo responsabile nei loro dati.',
  'member.phoneTitle': 'Telefono',
  'member.phoneSince': 'attivo dal {when}',
  'member.revokePhone': 'Revoca telefono',
  'member.phoneRevoked': 'Telefono revocato. Al prossimo accesso l’app chiederà di configurare di nuovo il telefono.',
  'member.revokeExplain': 'Usalo se il telefono è perso, rubato o sostituito. Da subito quel telefono non può più timbrare né aprire documenti nuovi. Il dipendente configura l’app sul nuovo telefono e i cedolini già inviati vanno rinviati (te lo segnala la pagina Cedolini).',
  'member.revokeReason': 'Motivo',
  'member.revokeReason.lost': 'Perso',
  'member.revokeReason.stolen': 'Rubato',
  'member.revokeReason.replaced': 'Sostituito con un altro telefono',
  'member.revokeReason.other': 'Altro',
  'member.revokeConfirm': 'Revoca questo telefono',
  'member.entriesExplain': 'Per chi non usa il proprio telefono o per correggere un giorno. Nell’app del dipendente appare «registrato da HR» con il motivo, e può contestarlo.',
  'member.recordPunch': 'Registra timbratura',
  'member.punchType': 'Tipo',
  'member.when': 'Data e ora',
  'member.reason': 'Motivo',
  'member.punchReasonPlaceholder': 'Es. lavora senza smartphone, confermato dal capo turno',
  'member.punchRecorded': 'Timbratura registrata.',
  'member.recordLeave': 'Registra assenza',
  'member.leaveType': 'Tipo di assenza',
  'member.from': 'Dal',
  'member.to': 'Al',
  'member.quantityDays': 'Giorni',
  'member.quantityHours': 'Ore',
  'member.protocol': 'Protocollo del certificato INPS',
  'member.leaveReasonPlaceholder': 'Es. certificato ricevuto dal medico, ferie concordate',
  'member.leaveRecorded': 'Assenza registrata.',
  'member.sickDurationAuto': 'Durata calcolata automaticamente in giorni di calendario dal periodo.',
  'payroll.showDocuments': 'Documenti',
  'payroll.hideDocuments': 'Nascondi',
  'payroll.withdrawnCount': '{n} ritirati',
  'payroll.withdrawn': 'Ritirato',
  'payroll.openedOn': 'Aperto il {when}',
  'payroll.notOpened': 'Non ancora aperto',
  'payroll.withdraw': 'Ritira',
  'payroll.withdrawTitle': 'Ritira il documento di {name}',
  'payroll.withdrawExplain': '«{title}» sparisce dall’app del dipendente e la chiave che lo apre viene distrutta: nessuno potrà più decifrarlo. Usalo se è stato inviato alla persona sbagliata o per errore.',
  'payroll.withdrawAlreadyOpened': 'Il destinatario lo ha già aperto.',
  'payroll.withdrawPlaceholder': 'Es. inviato alla persona sbagliata',
  'payroll.withdrawConfirm': 'Ritira il documento',
  'payroll.withdrawDone': 'Documento ritirato.',
  'payroll.withdrawBreach': 'Il destinatario l’aveva già scaricato: potrebbe averlo letto. Se era la persona sbagliata è una violazione di dati personali: l’azienda deve valutarla e, se c’è un rischio per l’interessato, notificarla al Garante entro 72 ore (art. 33 GDPR). Annotala nel registro delle violazioni.',
  'payroll.withdrawNotDownloaded': 'Non era ancora stato scaricato: nessuno l’ha letto.',
  'payroll.withdrawFileLater': 'Il file cifrato non è stato cancellato ora; senza la chiave è comunque illeggibile.',
  'payroll.withdrawResend': 'Per inviarlo alla persona giusta, carica di nuovo il PDF e assegna la pagina a mano.',
  'privacy.title': 'Richieste privacy (GDPR)',
  'privacy.intro': 'I dipendenti (e gli ex dipendenti, per 12 mesi) fanno queste richieste dall’app. La legge dà un mese per rispondere, prorogabile una volta di due mesi spiegando il motivo (art. 12 GDPR). Il dipendente legge la tua risposta nell’app.',
  'privacy.empty': 'Nessuna richiesta.',
  'privacy.emptyOpen': 'Nessuna richiesta da gestire.',
  'privacy.emptyClosed': 'Nessuna richiesta nello storico.',
  'privacy.tabOpen': 'Da gestire',
  'privacy.tabClosed': 'Storico',
  'privacy.results': 'Richieste {from}–{to} di {total}',
  'privacy.pagination': 'Pagine delle richieste privacy',
  'privacy.countUnavailable': 'Conteggio delle richieste privacy non disponibile',
  'privacy.received': 'Ricevuta',
  'privacy.kind': 'Tipo',
  'privacy.due': 'Scadenza',
  'privacy.overdue': 'Scaduta',
  'privacy.answer': 'Rispondi',
  'privacy.view': 'Vedi',
  'privacy.openCount': '{n} richieste aperte',
  'privacy.kind.access': 'Accesso ai dati',
  'privacy.kind.portability': 'Portabilità',
  'privacy.kind.erasure': 'Cancellazione',
  'privacy.kind.rectification': 'Rettifica',
  'privacy.kind.objection': 'Opposizione',
  'privacy.status.pending': 'Da gestire',
  'privacy.status.in_progress': 'In lavorazione',
  'privacy.status.completed': 'Evasa',
  'privacy.status.rejected': 'Respinta',
  'privacy.panelTitle': '{kind} · {name}',
  'privacy.receivedOn': 'Ricevuta il {when}',
  'privacy.dueOn': 'rispondere entro il {when}',
  'privacy.extended': 'prorogata',
  'privacy.extensionNote': 'Motivo della proroga: {note}',
  'privacy.guide.access': 'Il dipendente può scaricare da solo tutti i dati che Fide conserva (app → Privacy → Esporta). Nella risposta confermalo e aggiungi ciò che l’azienda tiene fuori da Fide (fascicolo cartaceo, gestionale paghe).',
  'privacy.guide.portability': 'L’esportazione dall’app (JSON) è già in formato portabile. Confermalo nella risposta e indica eventuali dati in altri sistemi.',
  'privacy.guide.erasure': 'Le presenze, i cedolini e i documenti del rapporto di lavoro vanno conservati per legge (art. 17.3.b GDPR; Libro Unico del Lavoro, 5 anni): di solito si risponde spiegandolo. Per un ex dipendente puoi cancellare subito ciò che non è obbligatorio (chiavi del telefono, notifiche).',
  'privacy.guide.rectification': 'Correggi i dati nella pagina Dipendenti (Gestisci → Dati) e conferma nella risposta cosa hai cambiato.',
  'privacy.guide.objection': 'Valuta se il trattamento si basa sul legittimo interesse: in quel caso va interrotto salvo motivi prevalenti, da spiegare nella risposta (art. 21 GDPR).',
  'privacy.answerLabel': 'Risposta al dipendente',
  'privacy.answerHint': 'Serve una risposta chiara: cosa hai fatto o perché non è possibile, e il diritto di reclamo al Garante.',
  'privacy.useTemplate': 'Usa il testo sulla conservazione obbligatoria',
  'privacy.template.erasureRetention': 'Abbiamo ricevuto la tua richiesta di cancellazione. Le timbrature, i cedolini e gli altri documenti del rapporto di lavoro devono essere conservati per obbligo di legge (art. 17, par. 3, lett. b, GDPR; Libro Unico del Lavoro, 5 anni) e non possono essere cancellati ora: lo saranno alla scadenza dei termini. Gli altri dati non necessari sono stati rimossi. Puoi proporre reclamo al Garante per la protezione dei dati personali.',
  'privacy.takeOn': 'Prendi in carico',
  'privacy.reject': 'Respingi',
  'privacy.complete': 'Segna come evasa',
  'privacy.eraseFormerExplain': 'Ex dipendente: puoi cancellare subito ciò che non è obbligatorio conservare. Si revocano le chiavi del suo telefono (i suoi documenti in Fide non si potranno più aprire) e si eliminano le notifiche. La richiesta si chiude con la risposta scritta qui sopra.',
  'privacy.eraseFormer': 'Cancella i dati non obbligatori e chiudi',
  'privacy.extendExplain': 'Richiesta complessa? Puoi prorogare di due mesi, una sola volta ed entro il primo mese. Il dipendente vedrà il motivo.',
  'privacy.extendPlaceholder': 'Motivo della proroga',
  'privacy.extend': 'Proroga di 2 mesi',

  // Requests: history and decision notes
  'requests.tabPending': 'Da gestire ({n})',
  'requests.tabHistory': 'Storico',
  'requests.approveTitle': 'Approva la richiesta di {name}',
  'requests.rejectTitle': 'Rifiuta la richiesta di {name}',
  'requests.noteRequired': 'Motivo del rifiuto',
  'requests.batchApprove': 'Approva selezionate ({n})',
  'requests.batchReject': 'Rifiuta selezionate ({n})',
  'requests.batchLimit': 'Fino a 50 richieste di assenza ordinaria alla volta.',
  'requests.selectPage': 'Seleziona tutte le richieste ordinarie in questa pagina',
  'requests.selectRequest': 'Seleziona la richiesta di {name}',
  'requests.batchApproveTitle': 'Approva {n} richieste',
  'requests.batchRejectTitle': 'Rifiuta {n} richieste',
  'requests.batchAtomic': 'L’operazione è tutto o niente: il server rivalida ogni richiesta e non ne modifica alcuna se una fallisce.',
  'requests.batchConfirm': 'Ho controllato ogni richiesta selezionata e confermo questa decisione.',
  'requests.noteOptional': 'Nota (facoltativa)',
  'requests.noteHint': 'Il dipendente la vede nell’app.',
  'requests.filterAllKinds': 'Tutti i tipi',
  'requests.filterAllOutcomes': 'Tutti gli esiti',
  'requests.outcome': 'Esito',
  'requests.status.approved': 'Approvata',
  'requests.status.rejected': 'Rifiutata',
  'requests.status.cancelled': 'Annullata',
  'requests.searchPerson': 'Cerca per nome',
  'requests.historyEmpty': 'Nessuna richiesta nello storico.',
  'requests.decidedBy': 'Deciso da',
  'requests.byHr': 'Registrata da HR',

  // Roles: team managers in the portal
  'member.role': 'Ruolo',
  'member.roleSave': 'Cambia ruolo',
  'member.roleHint': 'Il titolare nomina l’ufficio HR; l’HR nomina i responsabili.',
  'member.roleManagerHint': 'La squadra si assegna nel campo «Responsabile» di ogni dipendente. Nominare un responsabile non gli assegna automaticamente tutta l’azienda.',
  'access.managerScope': 'Vedi solo la tua squadra.',

  // Payslips: name cross-check
  'payroll.nameMissing': 'Nome del dipendente non trovato nelle pagine {pages}: controlla che siano sue.',
  'payroll.reviewTitle': 'Controlla prima di inviare',
  'payroll.reviewBody': 'Apri il link di ogni pagina e verifica che appartenga alla persona indicata. Anche se il codice fiscale coincide, controlla visivamente il documento. La casella si abilita dopo aver aperto il link; nessuna pagina viene cifrata o pubblicata senza conferma.',
  'payroll.reviewOpenFirst': 'Apri prima la pagina PDF per confermare l’assegnazione.',
  'payroll.reviewOpenPage': 'Apri pagina {page} del PDF',
  'payroll.reviewPageConfirm': 'Confermo che la pagina {page} appartiene a {name}.',
  'payroll.reviewGroup': '{name} · pagine {pages}',
  'payroll.reviewPageReference': 'Assegnazione: {match} · CF rilevato: {cf}',
  'payroll.match.cf': 'codice fiscale corrispondente',
  'payroll.match.continuation': 'continuazione della pagina precedente',
  'payroll.match.manual': 'selezione manuale',
  'payroll.issue.duplicate_employee': 'Il codice fiscale della pagina {page} è assegnato a più dipendenti. Dopo averla controllata, seleziona il destinatario corretto.',
  "member.tab.balances": "Saldi ferie e permessi",
  "balances.reload": "Ricarica i saldi prima di riprovare",
  "balances.year": "Anno",
  "balances.type": "Tipo di assenza",
  "balances.days": "giorni",
  "balances.hours": "ore",
  "balances.credited": "Maturato / accreditato nell’anno",
  "balances.carried": "Riporto anno precedente",
  "balances.sourceKind": "Fonte del saldo",
  "balances.sourceConsultant": "Consulente del lavoro",
  "balances.sourcePayslip": "Cedolini verificati",
  "balances.sourceOther": "Altra fonte verificata",
  "balances.asOfDate": "Saldo aggiornato al",
  "balances.sourceReference": "Riferimento / periodo (facoltativo)",
  "balances.referenceHint": "Non inserire diagnosi o dati sanitari; basta un periodo o un riferimento alle paghe.",
  "balances.summary": "Utilizzato totale: {used}; in attesa: {pending}; disponibile: {remaining} {unit}.",
  "balances.updated": "Aggiornato: {at}",
  "balances.saved": "Saldo salvato.",
  "balances.missing": "Saldo non caricato: il dipendente vede “non caricato”, non zero.",
  "balances.noTypes": "Nessun tipo di assenza con saldo attivo.",
  "balances.explain": "Carica accreditato lordo, riporto e utilizzato fuori Fide, verificati con le paghe. Fide sottrae anche le richieste approvate con inizio nell’anno scelto: non caricare un residuo netto né duplicare quelle richieste nell’utilizzato esterno. Dividi per anno le richieste a cavallo d’anno. HR aggiorna il maturato; nessun calcolo automatico per CCNL.",
  "balances.usedExternal": "Utilizzato fuori Fide (non duplicare le richieste già in Fide)",
  "balances.movements": "Movimenti Fide dopo la data del saldo: {n} {unit} (inclusi nel disponibile).",
  "balances.ledgerOnly": "Nessun saldo dichiarato: ci sono solo movimenti registrati in Fide. Indica fonte e data del saldo prima di salvarlo.",
  "monthClose.title": "Chiusura del mese",
  "monthClose.explain": "Chiudi un mese dopo averlo rivisto: non devono restare richieste in attesa. Da chiuso nessuno può modificarlo (richieste, decisioni, timbrature dimenticate, straordinari); le timbrature firmate dai telefoni restano sempre valide. Per riaprirlo serve un motivo, che resta nello storico.",
  "monthClose.month": "Mese",
  "monthClose.state": "Stato",
  "monthClose.open": "Aperto",
  "monthClose.closed": "Chiuso",
  "monthClose.reopened": "Riaperto",
  "monthClose.close": "Chiudi",
  "monthClose.reopen": "Riapri",
  "monthClose.reason": "Motivo della riapertura",
  "monthClose.confirmReopen": "Conferma riapertura",
  "monthClose.history": "Storico chiusure",
  "monthClose.errClosed": "Il mese è chiuso: per modificarlo l’ufficio del personale deve riaprirlo.",
  "monthClose.errPending": "Ci sono richieste in attesa in questo mese: decidile prima di chiuderlo.",
  "monthClose.errNotOver": "Si può chiudere solo un mese già terminato.",
  "monthClose.errReason": "Scrivi un motivo di almeno 10 caratteri.",
  "restricted.title": "Periodi non disponibili",
  "restricted.explain": "Date in cui i dipendenti non possono richiedere assenze (per esempio un picco di lavoro o l’inventario), per tutta l’azienda o una sede, per tutti i tipi o uno solo. I dipendenti li vedono. HR può comunque registrare un’assenza a nome di qualcuno. Malattia e Legge 104 non si possono mai bloccare.",
  "restricted.empty": "Nessun periodo.",
  "restricted.label": "Motivo visibile ai dipendenti",
  "restricted.from": "Dal",
  "restricted.to": "Al",
  "restricted.site": "Sede",
  "restricted.allSites": "Tutte le sedi",
  "restricted.type": "Tipo",
  "restricted.allTypes": "Tutti i tipi (tranne malattia e 104)",
  "restricted.add": "Aggiungi periodo",
  "restricted.delete": "Elimina",
  "restricted.errProtected": "Malattia e Legge 104 non si possono bloccare.",
  "restricted.errInvalid": "Controlla date (massimo un anno) e motivo.",
  "restricted.errBlocked": "Le date cadono in un periodo non disponibile per le richieste.",
  "balanceImport.button": "Importa saldi",
  "balanceImport.title": "Importa saldi dal consulente",
  "balanceImport.body": "Carica il file dei saldi (CSV o Excel salvato come CSV): codice fiscale, tipo (FERIE, ROL…), anno, maturato, riporto, utilizzato fuori Fide, data di riferimento e fonte. Fide controlla ogni riga e mostra prima/dopo; si applica tutto o niente. I movimenti di Fide successivi alla data di riferimento continuano a sommarsi.",
  "balanceImport.summary": "{ready} righe pronte, {errors} con errori, {negative} con disponibile negativo.",
  "balanceImport.person": "Persona",
  "balanceImport.type": "Tipo e anno",
  "balanceImport.before": "Ora (maturato + riporto − usato fuori)",
  "balanceImport.after": "Dal file",
  "balanceImport.available": "Disponibile dopo",
  "balanceImport.none": "Nessun saldo",
  "balanceImport.reconcileHint": "Il disponibile sottrae le richieste approvate in Fide nell’anno. Un valore negativo indica una differenza da verificare con il consulente prima di importare.",
  "balanceImport.apply": "Importa {n} righe",
  "balanceImport.done": "{n} saldi importati.",
  "balanceImport.rowFailed": "Riga {line}: {reason}. Nessun saldo è stato modificato.",
  "balanceImport.missing": "Mancano colonne obbligatorie: {columns}.",
  "balanceImport.tooMany": "Massimo {max} righe per file.",
  "balanceImport.col.codiceFiscale": "codice fiscale",
  "balanceImport.col.type": "tipo",
  "balanceImport.col.year": "anno",
  "balanceImport.col.entitled": "maturato",
  "balanceImport.col.carried": "riporto",
  "balanceImport.col.external": "utilizzato fuori",
  "balanceImport.col.asOf": "data di riferimento",
  "balanceImport.col.source": "fonte",
  "balanceImport.col.note": "riferimento",
  "balanceImport.issue.cf": "codice fiscale mancante",
  "balanceImport.issue.person": "nessun dipendente con questo codice fiscale",
  "balanceImport.issue.type": "tipo inesistente o senza saldo",
  "balanceImport.issue.year": "anno non valido",
  "balanceImport.issue.number": "valore non valido",
  "balanceImport.issue.date": "data non valida o fuori anno",
  "balanceImport.issue.futureDate": "data futura",
  "balanceImport.issue.source": "fonte: consulente, cedolino o altro",
  "balanceImport.issue.note": "riferimento troppo lungo",
  "balanceImport.issue.duplicate": "riga ripetuta",
  "balanceImport.issue.value": "valore non valido",
  "balanceImport.issue.other": "errore imprevisto",
  "nav.calendar": "Calendario assenze",
  "calendar.title": "Calendario assenze",
  "calendar.explainHr": "Assenze approvate e in attesa di tutta l’azienda o di una sede, con la copertura giorno per giorno. Rifiutate e annullate non compaiono.",
  "calendar.explainManager": "Assenze approvate e in attesa del tuo gruppo, con la copertura giorno per giorno. Per malattia e Legge 104 vedi solo «Assente», senza il motivo.",
  "calendar.previous": "Mese precedente",
  "calendar.next": "Mese successivo",
  "calendar.site": "Sede",
  "calendar.allSites": "Tutte le sedi",
  "calendar.legendLeave": "Assenza approvata",
  "calendar.legendPending": "In attesa",
  "calendar.legendRemote": "Smart working",
  "calendar.empty": "Nessuna persona da mostrare.",
  "calendar.person": "Persona",
  "calendar.absent": "Assenti",
  "calendar.private": "Assente",
  "calendar.pending": "in attesa",
  "delegations.title": "Deleghe di approvazione",
  "delegations.explain": "Durante un’assenza puoi passare le tue approvazioni a un altro responsabile o a HR, per massimo 90 giorni. La delega scade da sola, non passa ad altri e nessuno può approvare le proprie richieste.",
  "delegations.empty": "Nessuna delega.",
  "delegations.from": "Chi delega",
  "delegations.to": "Delegato",
  "delegations.period": "Periodo",
  "delegations.state": "Stato",
  "delegations.upcoming": "Programmata",
  "delegations.active": "Attiva",
  "delegations.ended": "Conclusa",
  "delegations.end": "Termina",
  "delegations.start": "Dal",
  "delegations.finish": "Al",
  "delegations.create": "Crea delega",
  "delegations.errPerson": "Il delegato deve essere un responsabile o HR attivo, diverso da chi delega.",
  "delegations.errDates": "Controlla le date: massimo 90 giorni e non nel passato.",
  "delegations.errOverlap": "C’è già una delega di questa persona in quelle date.",
  "leaveTypes.title": "Tipi di assenza",
  "leaveTypes.explain": "Nomi e regole dei tipi che i dipendenti possono richiedere. Un tipo con saldo richiede sempre la decisione di una persona. I tipi di sistema mantengono codice, unità e regole: puoi cambiare il nome e, se consentito, disattivarli.",
  "leaveTypes.name": "Nome",
  "leaveTypes.unit": "Unità",
  "leaveTypes.rules": "Regole",
  "leaveTypes.status": "Stato",
  "leaveTypes.system": "di sistema",
  "leaveTypes.protocol": "Protocollo INPS",
  "leaveTypes.approval": "Approvazione",
  "leaveTypes.noApproval": "Senza approvazione",
  "leaveTypes.balance": "con saldo",
  "leaveTypes.active": "Attivo",
  "leaveTypes.inactive": "Disattivato",
  "leaveTypes.edit": "Modifica",
  "leaveTypes.editTitle": "Modifica «{name}»",
  "leaveTypes.newTitle": "Nuovo tipo di assenza",
  "leaveTypes.new": "Aggiungi tipo",
  "leaveTypes.systemHint": "Tipo gestito da Fide: puoi cambiare solo il nome (e lo stato, dove consentito).",
  "leaveTypes.code": "Codice",
  "leaveTypes.tracksBalance": "Ha un saldo (ferie, permessi…)",
  "leaveTypes.requiresApproval": "Richiede approvazione",
  "leaveTypes.noApprovalWarning": "Senza approvazione le richieste risultano approvate subito. Usalo solo per comunicazioni che non richiedono una decisione.",
  "leaveTypes.errNeedsApproval": "Un tipo con saldo richiede sempre l’approvazione di una persona.",
  "leaveTypes.errReserved": "Questo codice è riservato a un tipo di sistema.",
  "leaveTypes.errExists": "Esiste già un tipo con questo codice.",
  "leaveTypes.errSystem": "Nei tipi di sistema puoi cambiare solo il nome e lo stato.",
  "leaveTypes.errRequired": "Malattia e Banca Ore devono restare attivi.",
  "leaveTypes.errRetired": "Lo straordinario si gestisce dalle richieste di straordinario: questo tipo resta disattivato.",
  "leaveTypes.errStale": "Un altro utente ha modificato il tipo. Ricarica e riprova.",
  "leaveTypes.errInUse": "Non puoi cambiare l’unità: il tipo è già usato in richieste o saldi.",
  "leaveTypes.grantedOnly": "solo abilitati",
  "leaveTypes.eligibility": "Chi può richiederlo",
  "leaveTypes.eligibilityEveryone": "Tutti i dipendenti attivi",
  "leaveTypes.eligibilityGranted": "Solo persone abilitate da HR",
  "leaveTypes.errEligibilityFixed": "Malattia e Ferie sono sempre per tutti; Legge 104 e Smart Working sempre solo per persone abilitate.",
  "leaveTypes.errNotEligible": "Questa persona non è abilitata a questo tipo di assenza per le date scelte.",
  "grants.title": "Abilitazioni",
  "grants.explain": "Chi può richiedere i tipi riservati (Legge 104, Smart Working…) e in quale periodo. Terminare un’abilitazione non cancella lo storico né le richieste in attesa.",
  "grants.empty": "Nessuna abilitazione.",
  "grants.type": "Tipo",
  "grants.from": "Dal",
  "grants.to": "Al",
  "grants.toOptional": "Al (facoltativo)",
  "grants.open": "Senza scadenza",
  "grants.end": "Termina",
  "grants.confirmEnd": "Conferma fine",
  "grants.add": "Abilita",
  "grants.self": "Le tue abilitazioni le gestisce un altro HR o il titolare.",
  "grants.privacy": "Solo persona, tipo e date: non inserire motivi, familiari, diagnosi o documenti. L’abilitazione la vedono solo HR, il titolare e l’interessato.",
  "grants.errOverlap": "Esiste già un’abilitazione per queste date.",
  "grants.errDates": "Controlla le date: la fine non può precedere l’inizio.",
  "ledger.title": "Movimenti registrati in Fide",
  "ledger.explain": "Accrediti di Banca Ore, rettifiche e storni. Non si modificano: un errore si corregge con uno storno. I movimenti fino alla data “Saldo aggiornato al” sono già compresi nel saldo della fonte e non vengono sommati di nuovo.",
  "ledger.empty": "Nessun movimento per questo anno.",
  "ledger.date": "Data",
  "ledger.kind": "Tipo",
  "ledger.quantity": "Quantità",
  "ledger.reason": "Motivo",
  "ledger.kindBancaOre": "Straordinario in Banca Ore",
  "ledger.kindAdjustment": "Rettifica HR",
  "ledger.kindReversal": "Storno",
  "ledger.included": "Già compreso nel saldo della fonte",
  "ledger.reverse": "Storna",
  "ledger.reverseReason": "Motivo dello storno",
  "ledger.confirmReverse": "Conferma storno",
  "ledger.adjustTitle": "Nuova rettifica",
  "ledger.quantitySigned": "Quantità ({unit}, negativa per togliere)",
  "ledger.adjust": "Registra rettifica",
  "ledger.notReversible": "Questo movimento non si può stornare (già stornato o è uno storno).",
  "presence.date": "Data (Italia)",
  "presence.resetToday": "Oggi",
  "presence.search": "Nome, matricola o ricevuta",
  "presence.siteFilter": "Sede della timbratura",
  "presence.managerFilter": "Responsabile assegnato",
  "presence.kindFilter": "Tipo",
  "presence.all": "Tutti",
  "presence.review": "Segnalazioni tecniche",
  "presence.scope": "Risultati filtrati: {filtered} / {total} timbrature del giorno. Le segnalazioni non sono richieste da approvare; le correzioni approvate restano visibili nella tabella.",
  "presence.lastIn": "Dipendenti nei risultati",
  "presence.lastInHint": "Persone con almeno una timbratura nei risultati filtrati; non è un conteggio dei presenti ora.",
  "presence.dayPunches": "Timbrature del giorno",
  "presence.noMatches": "Nessun risultato con questi filtri.",
  "presence.pagination": "Pagine delle timbrature",
  "presence.previous": "Precedente",
  "presence.next": "Successiva",
  "presence.page": "Pagina {page} di {pages}",
  "requests.searchEmployee": "Nome o matricola",
  "requests.assignedSite": "Sede assegnata",
  "requests.from": "Periodo richiesto: dal",
  "requests.to": "Periodo richiesto: al",
  "requests.resetFilters": "Azzera filtri",
  "requests.filterScope": "Sede e responsabile sono quelli attualmente assegnati. Le date selezionano il periodo di assenza o la timbratura richiesta, includendo i periodi sovrapposti; non la data della decisione.",
  "requests.invalidRange": "La data iniziale deve precedere o coincidere con quella finale.",
  "requests.pagination": "Pagine delle richieste",
  "requests.results": "Filtrate: {filtered} / {total} richieste",
  'allocation.title': 'Ripartizione giornaliera',
  'allocation.hint': 'Ripartisci il totale già approvato, senza modificarlo. Nessun giorno viene dedotto dal calendario attuale.',
  'allocation.add': 'Aggiungi giorno',
  'allocation.total': 'Totale ripartito',
  'allocation.confirm': 'Confermo i giorni e il totale approvato',
  'allocation.history': 'Versioni precedenti',
  'allocation.invalid': 'Date, quantità o totale non validi. Il totale approvato deve restare invariato.',
  'allocation.stale': 'Il reparto è cambiato. Ricarica per consultare la versione salvata prima di riprovare.',
  "budget.policy": "Calcolo assenze da calendario",
  "budget.policyHint": "Attiva il calcolo da calendario per giornate intere in giorni e permessi in ore secondo i turni programmati. Ogni giornata programmata viene attribuita alla data di inizio del turno, senza raddoppio a mezzanotte. Servono orari e calendari verificati. La malattia mantiene il percorso attuale. Non modifica il totale delle richieste precedenti né accredita ferie. Aggiornare e verificare le app prima di attivare: le versioni precedenti non possono inviare queste richieste.",
  "budget.enabled": "Attivo",
  "budget.disabled": "Disattivato",
  "budget.enable": "Attiva calcolo da calendario",
  "budget.disable": "Disattiva per nuove richieste",
  "budget.preview": "{count} giorni calcolati dal server",
  "budget.fullDays": "Il calcolo segue il turno e il calendario. I permessi in ore possono coprire una parte della giornata.",
  "budget.stale": "La configurazione è cambiata. Ricalcola prima di inviare. Per una richiesta pendente: annulla e ricrea la richiesta con il nuovo conteggio.",
  "budget.scheduleRequired": "Manca una giornata compatibile nel periodo. Chiedi a HR di completarla.",
  "budget.noWorkdays": "Nessuna giornata lavorativa programmata nel periodo.",
  "budget.error": "Impossibile calcolare la richiesta. Controlla i dati e riprova.",
  "budget.noSavedAllocation": "Questa richiesta non ha una ripartizione giornaliera salvata. Il totale non viene ricostruito dal calendario attuale.",
  'member.tab.onboarding': 'Checklist assunzione',
  'member.tab.deadlines': 'Scadenze',
  'onboarding.checklist.title': 'Pratiche e documenti di assunzione',
  'onboarding.checklist.hint': 'Verifica e spunta i moduli e documenti consegnati dal dipendente per l’assunzione. Il dipendente vede lo stato aggiornato nella sua app (I miei dati).',
  'onboarding.checklist.task.identity_document': 'Documento d’identità e codice fiscale',
  'onboarding.checklist.task.privacy_notice': 'Informativa privacy (art. 13 RGPD)',
  'onboarding.checklist.task.tfr_choice': 'Modulo scelta destinazione TFR (TFR 1 / TFR 2)',
  'onboarding.checklist.task.tax_deductions': 'Modulo detrazioni fiscali / carichi di famiglia',
  'onboarding.checklist.task.bank_details': 'Coordinate bancarie (IBAN accredito stipendio)',
  'onboarding.checklist.task.employment_contract': 'Contratto collegato alla versione del rapporto (non prova la firma)',
  'onboarding.checklist.task.individual_agreement': 'Accordo individuale previsto (non prova la firma)',
  'onboarding.checklist.status.completed': 'Completato',
  'onboarding.checklist.status.pending': 'In attesa',
  'onboarding.checklist.completedAt': 'Completato il {date}',
  'onboarding.checklist.completedBy': 'da {actor}',
  'onboarding.checklist.notes': 'Note interne HR',
  'onboarding.checklist.save': 'Salva modifiche',
  'onboarding.checklist.saved': 'Modifiche salvate con successo.',
  'deadlines.title': 'Scadenzario e adempimenti',
  'deadlines.hint': 'Monitoraggio delle scadenze contrattuali e degli obblighi di legge (periodo di prova, termine contratti, idoneità sanitaria, permesso di soggiorno, sicurezza).',
  'deadlines.horizon': 'Orizzonte temporale',
  'deadlines.horizon.30': 'Prossimi 30 giorni',
  'deadlines.horizon.60': 'Prossimi 60 giorni',
  'deadlines.horizon.90': 'Prossimi 90 giorni',
  'deadlines.horizon.365': 'Anno intero',
  'deadlines.category.probation_end': 'Fine prova',
  'deadlines.category.contract_end': 'Scadenza termine',
  'deadlines.category.medical_visit': 'Visita medica periodica (D.Lgs. 81/08)',
  'deadlines.category.residence_permit': 'Permesso di soggiorno',
  'deadlines.category.safety_training': 'Formazione sicurezza',
  'deadlines.urgency.expired': 'Scaduto',
  'deadlines.urgency.critical': 'Urgente (<= 15 gg)',
  'deadlines.urgency.warning': 'In scadenza (<= 30 gg)',
  'deadlines.urgency.upcoming': 'Programmata',
  'deadlines.daysRemaining': '{n} gg rimanenti',
  'deadlines.daysExpired': 'Scaduto da {n} gg',
  'deadlines.empty': 'Nessuna scadenza nel periodo selezionato.',

  'breaks.title': 'Politiche di pausa',
  'breaks.description': 'Regole aziendali per pause pranzo e caffè. Nessuna deduzione automatica.',
  'breaks.newPolicy': 'Nuova politica di pausa',
  'breaks.editPolicy': 'Modifica politica di pausa',
  'breaks.name': 'Nome',
  'breaks.nameRequired': 'Il nome deve contenere almeno 2 caratteri',
  'breaks.type': 'Tipo',
  'breaks.isPaid': 'Pausa retribuita (computabile come lavoro)',
  'breaks.isMandatory': 'Obbligatoria',
  'breaks.minDuration': 'Durata minima',
  'breaks.expectedDuration': 'Durata prevista',
  'breaks.validFrom': 'Valida dal',
  'breaks.validTo': 'Valida fino al',
  'breaks.minutes': 'minuti',
  'breaks.paid': 'Retribuita',
  'breaks.unpaid': 'Non retribuita',
  'breaks.mandatoryBadge': 'Obbligatoria',
  'breaks.activeIndefinitely': 'attiva a tempo indeterminato',
  'breaks.durations': 'Durata prevista / minima',
  'breaks.validity': 'Validità',
  'breaks.empty': 'Nessuna politica di pausa configurata.',
  'breaks.invalidDuration': 'La durata non può essere negativa',
  'breaks.invalidDates': 'La data di fine deve essere successiva a quella di inizio',

  'presence.liveTab': 'Presenze in tempo reale',
  'presence.exportTab': 'Esportazione presenze',
  'presence.breakStart': 'Inizio pausa',
  'presence.breakEnd': 'Fine pausa',

  'cartellino.tab': 'Cartellino mensile',
  'cartellino.title': 'Cartellino mensile',
  'cartellino.subtitle': 'Riepilogo mensile di presenze, pause, ore lavorate e anomalie per dipendente.',
  'cartellino.downloadPdf': 'Scarica PDF',
  'cartellino.pdfTitle': 'Cartellino mensile delle presenze',
  'cartellino.period': 'Mese di competenza',
  'cartellino.vatFiscalCode': 'P.IVA / Codice Fiscale',
  'cartellino.summary': 'Riepilogo del mese',
  'cartellino.employerSignature': 'Firma del datore di lavoro / HR',
  'cartellino.employeeSignature': 'Firma del lavoratore per presa visione e conformità',
  'cartellino.generatedAt': 'Generato il',
  'cartellino.footerNotice': 'Documento generato da Fide sulla base di registrazioni elettroniche inalterabili.',
  'cartellino.employee': 'Dipendente',
  'cartellino.prevMonth': 'Mese precedente',
  'cartellino.nextMonth': 'Mese successivo',
  'cartellino.workedDays': 'Giorni lavorati',
  'cartellino.totalDaysInMonth': '{count} giorni nel mese',
  'cartellino.computableHours': 'Ore computabili',
  'cartellino.expected': 'Previste',
  'cartellino.noSchedule': 'Nessun orario previsto',
  'cartellino.breaksSummary': 'Totale pause',
  'cartellino.paid': 'Retribuite',
  'cartellino.unpaid': 'Non retribuite',
  'cartellino.paidShort': 'retribuita',
  'cartellino.anomalies': 'Anomalie / Incidenze',
  'cartellino.anomaliesHint': 'Eventi da verificare o correggere',
  'cartellino.date': 'Giorno',
  'cartellino.punches': 'Timbrature',
  'cartellino.breaks': 'Pause',
  'cartellino.computable': 'Computabile',
  'cartellino.leaves': 'Assenze',
  'cartellino.status': 'Stato',
  'cartellino.regular': 'Regolare',
  'cartellino.missingOut': 'Mancata uscita',
  'cartellino.missingIn': 'Mancata entrata',
  'cartellino.unclosedBreak': 'Pausa non chiusa',
  'cartellino.breakWithoutStart': 'Fine pausa senza inizio',
  'cartellino.breakOutsideShift': 'Pausa fuori dal turno',
  'cartellino.shortBreak': 'Pausa inferiore al minimo',
  'cartellino.longShift': 'Turno oltre 16 ore',
  'cartellino.corrected': 'Correzione manuale',
  'cartellino.flagged': 'Segnalazione timbratura',
  'cartellino.scheduleDiscrepancy': 'Assenza ingiustificata',
  'common.days.mon': 'Lun',
  'common.days.tue': 'Mar',
  'common.days.wed': 'Mer',
  'common.days.thu': 'Gio',
  'common.days.fri': 'Ven',
  'common.days.sat': 'Sab',
  'common.days.sun': 'Dom',
  'compliance.status': "Stato amministrativo",
  'compliance.scheduled': "Programmato",
  'compliance.document_pending': "Documento in attesa",
  'compliance.verified': "Verificato",
  'breaks.versionRequired': "Crea una nuova versione con decorrenza successiva alle pause già registrate.",
  'error.bankConfiguration': "La banca ore deve essere attiva, in ore e con saldo gestito.",
  "schedule.copyDay": "Copia una giornata",
  "schedule.copyHint": "Copia tutti i tratti del giorno scelto, comprese le pause tra i tratti. Sostituisce i tratti dei soli giorni selezionati nell’editor: non salva né modifica le timbrature. Verifica poi il totale contrattuale e salva la nuova versione.",
  "schedule.copySource": "Giorno di origine",
  "schedule.copyTargets": "Giorni da sostituire",
  "schedule.copyInvalid": "Scegli una giornata con tratti validi. La copia deve rispettare il limite di 28 tratti e non creare sovrapposizioni, anche nella notte tra domenica e lunedì.",
  "schedule.copySummary": "Tratti esistenti sostituiti: {count}. Nuovo totale settimanale: {minutes} minuti.",
  "schedule.copyConfirm": "Ho controllato i giorni, gli orari e i tratti da sostituire.",
  "schedule.copyApply": "Applica copia nell’editor",
  "clockPolicy.methodsTitle": "Metodi di timbratura per ambito e data",
  "clockPolicy.methodsHint": "Il QR rimane sempre disponibile. La versione attiva più specifica prevale su squadra, sede e azienda. Le modifiche partono non prima di domani e sono applicate dal server.",
  "clockPolicy.company": "Azienda",
  "clockPolicy.site": "Sede",
  "clockPolicy.team": "Squadra",
  "clockPolicy.person": "Persona",
  "clockPolicy.scope": "Ambito",
  "clockPolicy.target": "Destinatario",
  "clockPolicy.from": "Valida dal",
  "clockPolicy.to": "Valida fino al (facoltativo)",
  "clockPolicy.allowGeo": "Consenti anche la timbratura con geofence sul dispositivo",
  "clockPolicy.geoLegal": "Attivare solo dopo la necessaria verifica giuslavoristica e privacy. Anche la sede deve avere il geofence abilitato; non vengono memorizzate coordinate.",
  "clockPolicy.source": "Riferimento della decisione o dell’accordo",
  "clockPolicy.confirmMethods": "Ho controllato ambito, date, metodo e riferimento giustificativo.",
  "clockPolicy.saveVersion": "Salva versione dei metodi",
  "clockPolicy.qrOnly": "Solo QR",
  "clockPolicy.qrGeo": "QR + geofence",
  "shifts.title": "Turni pianificati",
  "shifts.explain": "La pianificazione è separata dalle timbrature reali. Ogni modifica crea una nuova versione e un avviso non letto per il lavoratore. Sovrapposizioni e assenze approvate vengono bloccate.",
  "shifts.time": "Orario pianificato",
  "shifts.notice": "Avviso al lavoratore",
  "shifts.read": "Letto",
  "shifts.unread": "Non letto",
  "shifts.cancelled": "Annullato",
  "shifts.cancel": "Annulla turno",
  "shifts.cancelTitle": "Annulla il turno di {name}",
  "shifts.empty": "Nessun turno pianificato in questo periodo.",
  "shifts.add": "Pianifica un turno",
  "shifts.edit": "Modifica turno pianificato",
  "shifts.start": "Inizio",
  "shifts.end": "Fine",
  "shifts.reason": "Motivo di questa versione",
  "shifts.note": "Nota per il lavoratore (facoltativa)",
  "shifts.confirm": "Ho controllato persona, sede, orari, copertura e conflitti.",
  "approvalPolicies.title": "Livelli di approvazione",
  "approvalPolicies.explain": "Configura il percorso delle nuove richieste. Ogni richiesta conserva i livelli in vigore al momento dell’invio; un cambio non riscrive le decisioni già iniziate.",
  "approvalPolicies.empty": "Nessun tipo di assenza configurabile.",
  "approvalPolicies.leaveType": "Tipo di assenza",
  "approvalPolicies.flow": "Percorso",
  "approvalPolicies.flowFor": "Percorso di approvazione per {name}",
  "approvalPolicies.legacy": "Responsabile o HR (un livello)",
  "approvalPolicies.managerThenHr": "Responsabile, poi HR",
  "approvalPolicies.hrOnly": "Solo HR",
  "member.recordOvertime": "Registra straordinario",
  "member.overtimeRecorded": "Straordinario registrato.",
  "mealVouchers.title": "Buoni pasto (calcolo giornate)",
  "mealVouchers.explain": "Configura quando un dipendente matura un buono pasto nella giornata. Fide mostra il conteggio nel cartellino (portale e app) e lo include nell’esportazione mensile per il consulente.",
  "mealVouchers.enabled": "Attiva il calcolo dei buoni pasto",
  "mealVouchers.minMinutes": "Minuti lavorati minimi nella giornata (es. 360 = 6 ore)",
  "mealVouchers.includePaidBreaks": "Includi le pause retribuite nel raggiungimento della soglia",
  "mealVouchers.includeSmartWorking": "Includi le giornate di Smart Working approvate",
  "mealVouchers.save": "Salva regole buoni pasto",
  "mealVouchers.saved": "Regole dei buoni pasto salvate.",
  "mealVouchers.col": "Buoni pasto",
  "paghe.title": "Codici causale per il consulente (tracciato paghe)",
  "paghe.explain": "Associa alle voci di Fide (ore ordinarie, assenze, straordinari, buoni pasto) il codice causale usato dal software paghe dello studio (Zucchetti, TeamSystem, Inaz…). Lascia vuoto per usare il codice standard di Fide.",
  "paghe.fideCode": "Voce Fide",
  "paghe.consultantCode": "Codice gestionale paghe",
  "paghe.save": "Salva codice",
  "paghe.saved": "Codice salvato.",
  "paghe.item.ORD": "Ore ordinarie lavorate",
  "paghe.item.STRAORD_LIQ": "Straordinario da liquidare",
  "paghe.item.STRAORD_BANCA": "Straordinario in Banca Ore",
  "paghe.item.BUONO_PASTO": "Buono pasto maturato",
  "report.pagheCsv": "Scarica movimenti con codici paghe (CSV)",
  "report.variationsCsv": "Scarica variazioni del mese (CSV)",
  "report.variationsSummary": "{n} variazioni registrate nel mese (assunzioni/contratti, cessazioni, straordinari, rettifiche saldi, buoni pasto).",
  "report.var.col.kind": "Tipo variazione",
  "report.var.col.code": "Codice paghe",
  "report.var.col.date": "Data / Periodo",
  "report.var.col.value": "Valore / Dettaglio",
  "report.var.kind.hire_or_contract": "Contratto / Inquadramento",
  "report.var.kind.termination": "Cessazione rapporto",
  "report.var.kind.overtime": "Straordinario approvato",
  "report.var.kind.balance_adjustment": "Rettifica saldo",
  "report.var.kind.meal_vouchers": "Buoni pasto del mese",
  "communications.category": "Categoria comunicazione",
  "communications.cat.notice": "Avviso",
  "communications.cat.circular": "Circolare aziendale",
  "communications.cat.regulation": "Regolamento aziendale",
  "communications.cat.privacy_notice": "Informativa privacy (art. 13 RGPD)",
  "communications.cat.disciplinary_code": "Codice disciplinare (art. 7 L. 300/1970)",
  "communications.requiresAck": "Richiedi conferma esplicita di presa visione dall’app",
  "communications.requiresAckHint": "Non viene mai tracciata l’apertura passiva: viene registrata solo la conferma volontaria del lavoratore.",
  "communications.ackCount": "Presa visione: {n} conferme",
  "communications.ackShow": "Mostra conferme",
  "communications.ackHide": "Nascondi conferme",
  "communications.ackEmpty": "Nessuna conferma registrata finora.",
  "hrDesk.title": "Sportello HR e variazione dati anagrafici",
  "hrDesk.intro": "Richieste inviate dai lavoratori dall’app: cambio IBAN, cambio indirizzo, familiari a carico / detrazioni, certificato di servizio, anticipo TFR.",
  "hrDesk.empty": "Nessuna richiesta allo sportello HR.",
  "hrDesk.cat.iban_change": "Cambio IBAN",
  "hrDesk.cat.address_change": "Cambio indirizzo",
  "hrDesk.cat.family_dependents": "Familiari a carico / detrazioni",
  "hrDesk.cat.service_certificate": "Certificato di servizio",
  "hrDesk.cat.tfr_advance": "Anticipo TFR",
  "hrDesk.cat.other": "Altra richiesta HR",
  "hrDesk.status.pending": "In attesa",
  "hrDesk.status.completed": "Completata",
  "hrDesk.status.rejected": "Respinta",
  "hrDesk.status.cancelled": "Annullata",
  "hrDesk.manage": "Gestisci",
  "hrDesk.complete": "Segna come completata",
  "hrDesk.reject": "Respingi",
  "hrDesk.noteLabel": "Risposta o nota per il lavoratore",
  "hrDesk.noteRequired": "Motivazione obbligatoria in caso di rifiuto (min 3 caratteri)",
} as const;

